/* tslint:disable */
/* eslint-disable */
export enum ActionOriginType {
  Internal = 'INTERNAL',
  CivilSociety = 'CIVIL_SOCIETY',
  Business = 'BUSINESS',
  Other = 'OTHER',
}
